export default "__VITE_ASSET__26b333d8__"